import { render, staticRenderFns } from "./customerCRM.vue?vue&type=template&id=065d170a"
import script from "./customerCRM.vue?vue&type=script&lang=js"
export * from "./customerCRM.vue?vue&type=script&lang=js"
import style0 from "./customerCRM.vue?vue&type=style&index=0&id=065d170a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports